<template>
  <form-included-contacts
      :includedContacts.sync="incomingInvoice.includedContacts"
      :allowEmpty="false"
  />
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import FormIncludedContacts from '../../../form/includedContact/IncludedContacts'

export default {
  components: {
    FormIncludedContacts
  },
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    }
  },
  setup () {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>